module.exports = __webpack_public_path__ + "static/media/aloa_a.97481656.png";